import { render, staticRenderFns } from "./CalendarEstatistics.vue?vue&type=template&id=4bbc3d99&"
import script from "./CalendarEstatistics.vue?vue&type=script&lang=js&"
export * from "./CalendarEstatistics.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEstatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports